// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1SYNP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Hrpg"};